/* Banner home — initializare slider (slick e incarcat cu defer, deci DOMContentLoaded) */
(function () {
  function initBannerSliders() {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;

    window.jQuery('.home-banner__slides').each(function () {
      var $el = window.jQuery(this);
      if ($el.hasClass('slick-initialized')) return;

      var slideCount = parseInt($el.data('slide-count'), 10) || 1;
      var autoplay = $el.data('autoplay') === true || $el.data('autoplay') === 'true';
      var autoplaySpeed = parseInt($el.data('autoplay-speed'), 10) || 6000;

      $el.slick({
        dots: slideCount > 1,
        arrows: false,
        infinite: slideCount > 1,
        speed: 800,
        slidesToShow: 1,
        adaptiveHeight: false,
        autoplay: autoplay && slideCount > 1,
        autoplaySpeed: autoplaySpeed,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBannerSliders);
  } else {
    initBannerSliders();
  }

  /* theme editor: sectiunea se re-randeaza la fiecare modificare */
  document.addEventListener('shopify:section:load', initBannerSliders);
  document.addEventListener('shopify:block:select', function (event) {
    if (!event.target || !event.target.closest) return;
    var slide = event.target.closest('.home-banner__slide');
    var slider = slide && slide.closest('.home-banner__slides');
    var index = slide && parseInt(slide.getAttribute('data-slick-index'), 10);
    if (slider && !isNaN(index) && window.jQuery && window.jQuery(slider).hasClass('slick-initialized')) {
      window.jQuery(slider).slick('slickGoTo', index);
    }
  });
})();
